import React from 'react';
import { SEOCityAmenities } from '@customTypes/seoCityPages';
import { useSearchContext } from '@context/SearchContext2025';
import {
  getGreatCitiesLinks,
  getExperiencesInCityLinks,
  getFAQs,
} from '@components/SearchExperiment/SEO/SrpSeoHelper';
import SrpSeoFAQ from '@components/SearchExperiment/SEO/SrpSeoFAQ';
import SrpSeoSection from './SrpSeoSection';

interface Props {
  location: string;
  cityAmenities: SEOCityAmenities;
}

export default function SrpSeo({ cityAmenities, location }: Props) {
  const { searchParams } = useSearchContext();
  const { product_category: productCategory } = searchParams;
  const cityNameOnly = location.split(',')[0].trim();

  // data for FAQs section
  const FAQs = getFAQs(productCategory, cityNameOnly);

  // data for Experiences in city section
  const { title: experiencesInCityTitle, links: experiencesInCityLinks } =
    getExperiencesInCityLinks(
      searchParams.country_code,
      searchParams.state_code,
      searchParams.city,
      cityNameOnly,
      productCategory,
      cityAmenities,
    );

  // only show the more experiences in city section if there are more than 3 amenities
  const shouldShowExperienceInCity = experiencesInCityLinks.length >= 3;

  // data for Explore great cities section
  const { title: greatCitiesTitle, links: greatCitiesLinks } = getGreatCitiesLinks(
    // this assertion is needed since we changed it such that
    // product_category explicitly needs to be 'all', 'spa', 'pool', or 'day room'
    productCategory as Parameters<typeof getGreatCitiesLinks>[0],
  );

  return (
    <div className="flex flex-col p-spacing-md desktop:px-0">
      <div className="border-t border-solar-border-secondary my-spacing-md desktop:my-spacing-xl" />
      <SrpSeoFAQ questions={FAQs} />

      {shouldShowExperienceInCity && (
        <>
          <div className="border-t border-solar-border-secondary my-spacing-md desktop:my-spacing-xl" />
          <SrpSeoSection
            title={experiencesInCityTitle}
            links={experiencesInCityLinks}
            initiallyExpanded
          />
        </>
      )}

      <div className="border-t border-solar-border-secondary my-spacing-md desktop:my-spacing-xl" />
      <SrpSeoSection title={greatCitiesTitle} links={greatCitiesLinks} initiallyExpanded={false} />
      <div className="border-t border-solar-border-secondary my-spacing-md desktop:my-spacing-xl" />
    </div>
  );
}
